import { useDisclosure } from '@cardboard-ui/react';
import React, { useEffect, useState } from 'react';
import { useFolderItem } from '../../../ItemViewerProvider';
import { SavingChangesDialog } from '../SavingChangesDialog';
import { PublishReminderDialog } from '../PublishReminderDialog';
import { PublishReminderDialog_folderItem$key } from '../PublishReminderDialog/__generated__/PublishReminderDialog_folderItem.graphql';

interface CloseConfirmationDialogProps {
  isUpdatingPage?: boolean;
  changedPage?: boolean;

  node: PublishReminderDialog_folderItem$key;
  isDraft: boolean;
}

export const CloseConfirmationDialog = ({
  isUpdatingPage,
  changedPage,
  node,
  isDraft,
}: CloseConfirmationDialogProps) => {
  const { closeViewer, setCloseHandler } = useFolderItem();
  const [shouldCloseItemViewer, setShouldCloseItemViewer] = useState(false);

  useEffect(() => {
    setCloseHandler(() => setShouldCloseItemViewer(true));
    return () => setCloseHandler(undefined);
  }, []);

  const {
    isOpen: isDiscardConfirmationDialogOpen,
    onOpen: onDiscardConfirmationDialogOpen,
    onClose: onDiscardConfirmationDialogClose,
  } = useDisclosure();

  const {
    isOpen: isPublishReminderDialogOpen,
    onOpen: onPublishReminderDialogOpen,
    onClose: onPublishReminderDialogClose,
  } = useDisclosure();

  useEffect(() => {
    if (!shouldCloseItemViewer) {
      return;
    }

    if (isDraft) {
      onPublishReminderDialogOpen();
    } else if (isUpdatingPage || changedPage) {
      onDiscardConfirmationDialogOpen();
    } else {
      closeViewer();
    }
  }, [shouldCloseItemViewer, isDraft, isUpdatingPage, changedPage]);

  return (
    <>
      <SavingChangesDialog
        isOpen={isDiscardConfirmationDialogOpen}
        onClose={onDiscardConfirmationDialogClose}
      />

      <PublishReminderDialog
        folderItem={node}
        isOpen={isPublishReminderDialogOpen}
        onClose={onPublishReminderDialogClose}
        persistingChanges={!!(isUpdatingPage || changedPage)}
      />
    </>
  );
};
